// extracted by mini-css-extract-plugin
module.exports = {"root":"copy-link-success_root__3GSnh","entered":"copy-link-success_entered__2T0TC"};